var render = function render(){var _vm=this,_c=_vm._self._c;return _c('listSuncategoriesComponent',{attrs:{"category":_vm.category}})
}
var staticRenderFns = []

export { render, staticRenderFns }